exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".ly-helper-text {\n    margin-top: 0.25rem;\n    font-size: 0.875rem;\n    line-height: 1.25rem;\n    color: var(--secondary-content-color)\n}\n", ""]);

